import apiClient from '@src/api/clients';

const URL = 'app1/facebook-pages/';

/**
 * Pages, optionally for one client ('unassigned' for Pages with no client).
 * Inactive Pages are hidden unless asked for; `spare` keeps only Pages with no
 * client and nothing running.
 */
export const listFacebookPages = ({ client, includeInactive, spare, reusable, restricted } = {}) =>
  apiClient.request({
    url: URL,
    method: 'GET',
    payload: {
      ...(client ? { client } : {}),
      ...(includeInactive ? { include_inactive: '1' } : {}),
      ...(spare ? { spare: '1' } : {}),
      ...(reusable ? { reusable: '1' } : {}),
      ...(restricted ? { restricted: '1' } : {}),
    },
  });

export const createFacebookPage = (payload) =>
  apiClient.request({ url: URL, method: 'POST', payload });

/**
 * Nickname, tier, active, or a client for a spare Page. Which Page local ads
 * use is set in the Local Ad Builder.
 */
export const updateFacebookPage = (id, payload) =>
  apiClient.request({ url: `${URL}${id}/`, method: 'PATCH', payload });

/** Pages with no client that nobody has decided on yet, guessed ones first. */
export const listPagesToReview = () =>
  apiClient.request({ url: URL, method: 'GET', payload: { review: '1' } });

/** Give several Pages to clients at once: [{ id, client }]. */
export const assignFacebookPages = (assignments) =>
  apiClient.request({ url: `${URL}assign/`, method: 'POST', payload: { assignments } });

/** Spare, unassigned and mismatched counts, and when Facebook was last read. */
export const fetchFacebookPageSummary = () =>
  apiClient.request({ url: `${URL}summary/`, method: 'GET' });

/**
 * Read Pages from Facebook now. With client_id, that client's Pages come back
 * refreshed; without, every Page is refreshed in the background (202).
 */
export const refreshFacebookPages = (payload = {}) =>
  apiClient.request({ url: `${URL}refresh/`, method: 'POST', payload });

/** What setting a Page up for a client would change: defaults, preview, landing page. Reads only. */
export const fetchPageSetupPreview = (id, params = {}) =>
  apiClient.request({ url: `${URL}${id}/setup-preview/`, method: 'GET', payload: params });

/** Set a Page up for a client: copy the profile, point the website at the landing page, use for local. */
export const setupFacebookPage = (id, payload) =>
  apiClient.request({ url: `${URL}${id}/setup/`, method: 'POST', payload });

export const fetchFacebookPage = (id) =>
  apiClient.request({ url: `${URL}${id}/`, method: 'GET' });

/** Spare Pages one client could take, best first, each with why it's listed. Reads only. */
export const listSpareChoices = (clientId) =>
  apiClient.request({ url: `${URL}spare-choices/`, method: 'GET', payload: { client_id: clientId } });

/** Give a client a spare Page (`page` = row id; omit for the best one) and set it up from their record. */
export const claimSparePage = (clientId, page) =>
  apiClient.request({
    url: `${URL}claim-spare/`,
    method: 'POST',
    payload: { client_id: clientId, ...(page ? { page } : {}) },
  });
